import React, { useCallback, useState } from "react";
import PT from "prop-types";
import Section from "./Section";
import PlusIcon from "_c/icon/Plus";
import isempty from "lodash/isEmpty";
import Info from "_c/atoms/Info";
import * as S from "./styled";
import { Context } from "./context";
import SectHeader from "_c/modules/profile/common/SectHeader";
import ServicesFilter from "./Filter";
import { analyticsAction } from "@/utils/analytics";
import { useMasterServiceEditor } from "@/hooks/useMasterServiceEditor";
import ServicesImportModal from "_c/Modals/services-import-modal";
import { Menu, MenuItem } from "_c/Menu";

const Services = ({ t, ...props }) => {
  const [isImportOpen, setIsImportOpen] = useState(false);
  const openEditor_ = useMasterServiceEditor();
  const openEditor = useCallback(
    (maybeService) => {
      if (!maybeService) {
        analyticsAction({
          category: "profile",
          action: "service_form_opened_profile",
        });
      }
      openEditor_({
        masterId: props.masterId,
        service: maybeService,
      });
    },
    [openEditor_, props.masterId],
  );
  return (
    <S.Wrap id="master-services-container">
      <Context.Provider
        value={{
          t: t,
          authUserId: props.authUserId,
          deleteDiscount: props.deleteDiscount,
          createDiscount: props.createDiscount,
          addPortfolio: props.addPortfolio,
          openGallery: props.openGallery,
          updateDiscount: props.updateDiscount,
          clients: props.clients,
          basket: props.basket,
          addToBasket: props.addToBasket,
          removeFromBasket: props.removeFromBasket,
        }}
      >
        <SectHeader>
          {t(
            `master_profile:services_head_${props.isOwner ? "owner" : "guest"}`,
          )}
        </SectHeader>
        {props.isOwner && (
          <S.AddSect>
            <Menu
              menuButton={
                <S.AddSpecBtn greenish large withIcon>
                  <PlusIcon color="white" />
                  <span>{t("master_profile:icons.add_service")}</span>
                </S.AddSpecBtn>
              }
            >
              <MenuItem onClick={() => openEditor()}>
                {t("master_profile:add_service_manual")}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setIsImportOpen(true);
                  analyticsAction({
                    category: "services",
                    action: "services_import_click",
                  });
                }}
              >
                {t("master_profile:add_service_import")}
              </MenuItem>
            </Menu>
          </S.AddSect>
        )}
        <ServicesFilter
          t={t}
          value={props.servicesFilter}
          onChange={props.updateServicesFilter}
        />
        {isempty(props.services) ? (
          <Info cta={props.isOwner}>
            {t(
              `master_profile:blocks_empty.${
                props.isOwner ? "services_user" : "services_guest"
              }`,
            )}
          </Info>
        ) : (
          props.services.map(({ spec, services }) => (
            <Section
              isOwner={props.isOwner}
              key={spec._id}
              spec={spec}
              openEditor={openEditor}
              openAuthModal={props.openAuthModal}
              services={services}
              masterId={props.masterId}
            />
          ))
        )}
      </Context.Provider>
      <ServicesImportModal
        isOpen={isImportOpen}
        onClose={() => setIsImportOpen(false)}
      />
    </S.Wrap>
  );
};
Services.propTypes = {
  authUserId: PT.string,
  isOwner: PT.bool,
  openAuthModal: PT.func,
  services: PT.array,
  basket: PT.array,
  masterId: PT.string.isRequired,
  clients: PT.array,
  servicesFilter: PT.string,

  t: PT.func.isRequired,
  addPortfolio: PT.func.isRequired,
  createDiscount: PT.func.isRequired,
  updateDiscount: PT.func.isRequired,
  deleteDiscount: PT.func.isRequired,
  updateServicesFilter: PT.func.isRequired,
  addToBasket: PT.func.isRequired,
  removeFromBasket: PT.func.isRequired,
  openGallery: PT.func.isRequired,
};

export default Services;
